// extracted by mini-css-extract-plugin
module.exports = {"icon":"RelationshipFeedbackDisplayModal_icon__2gbv4","error":"RelationshipFeedbackDisplayModal_error__3N61j"};